<div class="page">
  <div class="check-message">
    <p trans="face_check.check.biometrics.upload"></p>
    <p trans="face_check.check.refresh"></p>
  </div>

  <div class="bottom-area">
    <div class="ring-and-message-container">
      <app-progress-ring
        [progress]="progress"
        [size]="72"
      >
      </app-progress-ring>
      <span class="progress-message">{{ progressMessage }}</span>
    </div>
  </div>
</div>
